import React from 'react';
import {useStyles} from '@unthinkable/react-theme';
import {IconButton as ButtonComponent} from '@unthinkable/react-button';
import {IconButtonStyle} from './theme';

export const IconButton = props => {
  const style = useStyles(IconButtonStyle);
  return <ButtonComponent styles={style} {...props} />;
};
